import React from 'react';
import i18next from 'i18next';
import * as S from '~/pages/Match/subpages/Previous/subpages/ArbitrationTeam/components/ArbitrationBlock/components/ArbitrationMatches/styles';

export const tableStructure = totalMatches => {
  return [
    {
      Header: i18next.t('season'),
      accessor: 'season',
      Footer: <S.Total>{i18next.t('total')}</S.Total>,
    },
    {
      Header: `${i18next.t('arbitratedMatches')}`,
      accessor: 'arbitratedMatches',
      Footer: totalMatches.arbitratedMatches,
    },
    {
      Header: `${i18next.t('yellowCards')} (L/V)`,
      accessor: 'yellowCards',
      Footer: `${totalMatches.yellowCards.homeStat} / ${totalMatches.yellowCards.awayStat}`,
    },
    {
      Header: `${i18next.t('doubleYellowCards')} (L/V)`,
      accessor: 'doubleYellowCards',
      Footer: `${totalMatches.doubleYellowCards.homeStat} / ${totalMatches.doubleYellowCards.awayStat}`,
    },
    {
      Header: `${i18next.t('redCards')} (L/V)`,
      accessor: 'redCards',
      Footer: `${totalMatches.redCards.homeStat} / ${totalMatches.redCards.awayStat}`,
    },
    {
      Header: `${i18next.t('faultsIndicated')} (L/V)`,
      accessor: 'faultsIndicated',
      Footer: `${totalMatches.faultsIndicated.homeStat} / ${totalMatches.faultsIndicated.awayStat}`,
    },
    {
      Header: `${i18next.t('penaltiesIndicated')} (L/V)`,
      accessor: 'penaltiesIndicated',
      Footer: `${totalMatches.penaltiesIndicated.homeStat} / ${totalMatches.penaltiesIndicated.awayStat}`,
    },
  ];
};
